<div class="list-wrap">
  <div class="container">
    <div class="list-header">
      <div class="list-header-text">
        <p class="crumbs">
          <a [appHref]="'/'" [innerHTML]="'HOME' | translate | htmlToText | safe"></a> /
        </p>
        <h1 class="h2 title is-big" [innerHTML]="'TITOLO_PAGAMENTO_ANNULLATO' | translate| htmlToText | safe"></h1>
      </div>
    </div>
    <div class="block block-text">
      <div class="container">
        <div class="wrap">
          <div class="content">
            <p class="text-big" [innerHTML]="'TESTO_PAGAMENTO_ANNULLATO' | translate | htmlToText | safe"></p>
            <div style="margin-top: 1em;">
              <a [appHref]="'/'" class="button is-primary" [innerHTML]="'BOTTONE_PAGAMENTO_ANNULLATO' | translate | htmlToText  | safe"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
